/*global require: false */
require(['jquery',
    'validate',
    'unobtrusive',   
    'validateAll', 
    'mvcFoolProofValidate'],
function ($) {
    'use strict';

    // If company is NOT in business in 2022, hide question 
    $('input[name=IsInBusinessCurrentYear]').change(function () {
        if ($('input[name=IsInBusinessCurrentYear]:checked').val() == 'YES') {
            $("#Has20EmployeesInCurrentYearQuestion").show('200');
            $("#EvaluationDateQuestion").show('200');
            $("#PEOCoverageQuestion").show('200');
                               
        }
        else {
            $("#Has20EmployeesInCurrentYearQuestion").hide('200');
            $("#TwentyEmployeeThresholdDateQuestion").hide('200');
            $("#EvaluationDateQuestion").hide('200');
            $("#Has100EmployeesInCurrentYearQuestion").hide('200');
            $("#PEOCoverageQuestion").show('200');
            $('#PeoNameQuestion').hide('200');

            // reset the values
            $("input[name=Has20EmployeesInCurrentYear]").prop('checked', false);
            $("#TwentyEmployeeThresholdDate").val('');
            $("#EvaluationDate").val('');
            $("input[name=Has100EmployeesInCurrentYear]").prop('checked', false);
            $("input[name=HasPEOCoverage]").prop('checked', false);
            $("#PeoName").val('');

                  
        }
    });
      
    
    // if company DOESNT have ATLEAST 20 employees in the 2022 year, hide questions related to > 20 employees
    $('input[name=Has20EmployeesInCurrentYear]').change(function () {
        if ($('input[name=Has20EmployeesInCurrentYear]:checked').val() == 'YES') {
            $('#TwentyEmployeeThresholdDateQuestion').show('200');
        }
        else {
            $('#TwentyEmployeeThresholdDateQuestion').hide('200');
            $("#TwentyEmployeeThresholdDate").val('');
        }
    });

    // if company has other coverage obtained from PEO (professional employer organization) or
    // multiple employer welfare arrangement (MEWA), show PeoName text box
    $('input[name=HasPEOCoverage]').change(function () {
        if ($('input[name=HasPEOCoverage]:checked').val() == 'YES') {
            $('#PeoNameQuestion').show('200');
        }
        else {
            $('#PeoNameQuestion').hide('200');
            $("#PeoName").val('');
        }
    });

    $('input[name=IsBrandNewBusiness]').change(function () {
        if ($('input[name=IsBrandNewBusiness]:checked').val() == 'YES') {
            $('#BrandNewCustomers').show('200');
            $('#BusinessStartDatequestion').show('200');
            $('#EmployeeCountquestion').show('200');
            $('#Has20EmployeesInCurrentYearQuestion').show('200');
            //$('#TwentyEmployeeThresholdDateQuestion').show('200');
            $('#EmployerSizeText').show('200');

            $('#CompanyGroupNumber').hide('200');
            $('#IsInBusinessLastYearQuestion').hide('200');
            $("#IsInBusinessLastYear").val('');
            $('#Has20EmployeesInLastYearQuestion').hide('200');
            $("#Has20EmployeesInLastYear").val('');
            $('#Has100EmployeesInLastYearQuestion').hide('200');
            $("#Has100EmployeesInLastYear").val('');

            $("input[name=Has20EmployeesInLastYear]").prop('checked', false);
            $("input[name=Has100EmployeesInLastYear]").prop('checked', false);
            $("input[name=IsInBusinessLastYear]").prop('checked', false);
        }
        else {
            $('#BrandNewCustomers').hide('200');
            $('#BusinessStartDatequestion').hide('200');
            $("#BusinessStartDate").val('');
            $('#EmployeeCountquestion').hide('200');
            $("#EmployeeCount").val('');
            $('#Has20EmployeesInCurrentYearQuestion').hide('200');
            $("#Has20EmployeesInCurrentYear").val('');
            $('#TwentyEmployeeThresholdDateQuestion').hide('200');
            $("#TwentyEmployeeThresholdDate").val('');

            $('#CompanyGroupNumber').show('200');
            $('#IsInBusinessLastYearQuestion').show('200');
            $('#Has20EmployeesInLastYearQuestion').show('200');
            $('#Has100EmployeesInLastYearQuestion').show('200');

            $("input[name=Has20EmployeesInCurrentYear]").prop('checked', false);
            $("#TwentyEmployeeThresholdDate").val('');
            $("#EvaluationDate").val('');
            $("input[name=Has100EmployeesInCurrentYear]").prop('checked', false);
            //$("input[name=HasPEOCoverage]").prop('checked', false);
            //$("#PeoName").val('');
            if ($('input[name=IsInBusinessLastYear]:checked').val() == 'NO') {
                $('#Has20EmployeesInLastYearQuestion').hide('200');
                $('#Has100EmployeesInLastYearQuestion').hide('200');
                $('#EmployerSizeText').hide('200');
                $("input[name=Has20EmployeesInLastYear]").prop('checked', false);
                $("input[name=Has100EmployeesInLastYear]").prop('checked', false);
            }
            else {
                $('#Has20EmployeesInLastYearQuestion').show('200');
                $('#Has100EmployeesInLastYearQuestion').show('200');
                $('#EmployerSizeText').show('200');
            }
        }
    });

    $('input[name=IsInBusinessLastYear]').change(function () {
        if ($('input[name=IsInBusinessLastYear]:checked').val() == 'NO' && $('input[name=IsBrandNewBusiness]:checked').val() == 'NO') {
            $('#Has20EmployeesInLastYearQuestion').hide('200');
            $('#Has100EmployeesInLastYearQuestion').hide('200');
            $('#EmployerSizeText').hide('200');
            $("input[name=Has20EmployeesInLastYear]").prop('checked', false);
            $("input[name=Has100EmployeesInLastYear]").prop('checked', false);
        }
        else {
            $('#Has20EmployeesInLastYearQuestion').show('200');
            $('#Has100EmployeesInLastYearQuestion').show('200');
            $('#EmployerSizeText').show('200');
        }
    });

    function toggleEmployeesQuestion() {
        if ($('#Range100Plus').is(':checked')) {
            $('#Has100EmployeesInCurrentYearQuestion').show();
        } else {
            $('#Has100EmployeesInCurrentYearQuestion').hide();

            $('#Has100EmployeesInCurrentYearYes').prop('checked', false);
            $('#Has100EmployeesInCurrentYearNo').prop('checked', false);
            $('#Has100EmployeesInLastYearYes').prop('checked', false);
            $('#Has100EmployeesInLastYearNo').prop('checked', false);
        }
    }

    toggleEmployeesQuestion();

    $('input[name="EmployeeRangeInCurrentYear2026"]').change(function () {
        toggleEmployeesQuestion();
    });
    $('form').submit(function (e) {
        var groupNumber = $('#HmsaNineDigitGroupNumber').val().trim();
        var accountCode = $('#HmsaAlphaAccountCode').val().trim();

        if (groupNumber === "" && accountCode === "") {
            $('#AtLeastOneRequiredError').show();
        } else {
            $('#AtLeastOneRequiredError').hide();
        }
    });

    $('#HmsaNineDigitGroupNumber, #HmsaAlphaAccountCode').on('input', function () {
        if ($('#HmsaNineDigitGroupNumber').val().trim() !== "" || $('#HmsaAlphaAccountCode').val().trim() !== "") {
            $('#AtLeastOneRequiredError').hide();
        }
    });

    function togglePeoInputSection() {
        if ($("#HasPEOCoverageYes").is(":checked")) {
            $("#PeoNameQuestion").show();
        } else {
            $("#PeoNameQuestion").hide();
            if ($("#HasPEOCoverageNo").is(":checked")) {
                $("#PeoNameInput").val("");
            }
        }
    }
    togglePeoInputSection();

    $(".peo-radio").change(function () {
        togglePeoInputSection();
    });
    
});
define("employer-size-survey-new", function(){});

